/* ALBEUX SLIDE WARM (2 Nov 2026). Loaded from snippets/view-transition-opt-in.liquid, next to albeux-slide.js. It does NOT change albeux-slide.js and nothing about the slide (length, curve, dim, landing, details opening).
   WHY: when a product is tapped in a collection, albeux-slide.js had to fetch the product page and wait for its first photograph before the slide could start, so the page began to move a moment late.
   WHAT IT DOES: it gets the product page and its first photograph ready BEFORE the tap, so at the tap the page is already in hand and the slide starts straight away.
   1. The product pages of the photographs on screen (and a little below) are fetched quietly, one at a time, a moment after the collection page has settled and again when scrolling stops. At most 12 per visit; none on Data Saver or a slow connection.
   2. The first photograph of each of those pages is loaded into the phone's picture memory (same size the product page will ask for), so it is there at once when the page is built.
   3. The instant a finger goes down (or the mouse rests on a product for a fraction of a second) that product is fetched ahead of everything else.
   4. When albeux-slide.js asks for one of these pages it is handed the page already fetched (a copy of it), and only when that page is a plain product page request for text/html. Every other request is left exactly as it is.
   If anything is missing or fails, the request simply goes the normal way. Reduced-motion visitors and the theme editor are left alone.
   To switch it off, delete the albeux-slide-warm line in snippets/view-transition-opt-in.liquid. */
(function () {
  'use strict';
  if (window.__albSlideWarm) return;
  window.__albSlideWarm = true;
  var d = document.documentElement;
  try {
    if (window.top !== window || d.classList.contains('shopify-design-mode')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.fetch || !window.DOMParser || !window.Promise) return;
  } catch (e) { return; }

  var conn = navigator.connection || {};
  var saver = !!conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
  var origFetch = window.fetch;
  var cache = Object.create(null);
  var TTL = 180000;
  var AHEAD_MAX = 12;
  var ahead = 0;
  var timer = 0;

  function abs(u) { try { return new URL(u, location.href).href; } catch (e) { return ''; } }
  function isProdUrl(u) { try { return new URL(u).pathname.indexOf('/products/') > -1; } catch (e) { return false; } }
  function fresh(u) { var c = cache[u]; return !!(c && Date.now() - c.t < TTL); }
  function onCollection() { return d.getAttribute('data-alb-tpl') === 'collection'; }
  function acceptsHtml(init) {
    try {
      var h = init && init.headers;
      if (!h) return false;
      var a = (typeof h.get === 'function') ? h.get('Accept') : (h.Accept || h.accept);
      return String(a || '').indexOf('text/html') > -1;
    } catch (e) { return false; }
  }

  /* The first photograph of the product page goes into picture memory, asked for the way the product page will ask for it */
  function photo(html, c) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var img = doc.querySelector('#MainContent media-gallery img, main media-gallery img');
      if (!img) return;
      var im = new Image();
      var sizes = img.getAttribute('sizes');
      var srcset = img.getAttribute('srcset');
      if (sizes) im.sizes = sizes;
      if (srcset) im.srcset = srcset;
      im.decoding = 'async';
      im.src = img.getAttribute('src') || '';
      c.im = im;
      if (im.decode) im.decode().catch(function () {});
    } catch (e) {}
  }

  function warm(u) {
    u = abs(u);
    if (!u || !isProdUrl(u) || fresh(u)) return;
    var p = origFetch.call(window, u, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
    var c = cache[u] = { p: p, t: Date.now(), im: null };
    p.then(function (r) {
      if (!r.ok) { delete cache[u]; return; }
      return r.clone().text().then(function (html) { photo(html, c); });
    }).catch(function () { delete cache[u]; });
  }

  /* albeux-slide.js asks for the page the usual way; if it is already here it gets a copy of it */
  window.fetch = function (input, init) {
    var args = arguments;
    try {
      var u = abs(typeof input === 'string' ? input : (input && input.url));
      var plain = !init || !init.method || String(init.method).toUpperCase() === 'GET';
      if (u && plain && fresh(u) && acceptsHtml(init)) {
        return cache[u].p.then(function (r) { return r.clone(); }, function () { return origFetch.apply(window, args); });
      }
    } catch (e) {}
    return origFetch.apply(this, args);
  };

  /* The finger goes down or the mouse rests on a product: fetch it now */
  function linkOf(t) { return t && t.closest ? t.closest('a[href*="/products/"]') : null; }
  function onIntent(e) {
    try {
      if (!onCollection()) return;
      var a = linkOf(e.target);
      if (a && a.origin === location.origin) warm(a.href);
    } catch (x) {}
  }
  document.addEventListener('pointerdown', onIntent, { passive: true, capture: true });
  document.addEventListener('touchstart', onIntent, { passive: true, capture: true });
  var ht = 0;
  document.addEventListener('mouseover', function (e) {
    var a = linkOf(e.target);
    if (!a) return;
    clearTimeout(ht);
    ht = setTimeout(function () { try { if (onCollection() && a.origin === location.origin) warm(a.href); } catch (x) {} }, 40);
  }, { passive: true });

  /* The products on screen (and a little below) are made ready one at a time */
  function visible() {
    var out = [];
    var seen = {};
    var main = document.querySelector('main[data-template^="collection"]');
    if (!main) return out;
    var list = main.querySelectorAll('a[href*="/products/"]');
    var h = window.innerHeight || 800;
    for (var i = 0; i < list.length; i++) {
      var a = list[i];
      if (a.origin !== location.origin) continue;
      var r = a.getBoundingClientRect();
      if (!r.width || r.bottom < 0 || r.top > h * 1.25) continue;
      var u = abs(a.href);
      if (!u || seen[u] || fresh(u)) continue;
      seen[u] = 1;
      out.push(u);
    }
    return out;
  }
  function pump() {
    if (saver || document.hidden || !onCollection() || ahead >= AHEAD_MAX) return;
    var q = visible();
    if (!q.length) return;
    ahead++;
    warm(q[0]);
    timer = setTimeout(pump, 220);
  }
  function schedule(ms) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      if ('requestIdleCallback' in window) requestIdleCallback(pump, { timeout: 1200 }); else pump();
    }, ms);
  }
  if (document.readyState === 'complete') schedule(400); else window.addEventListener('load', function () { schedule(400); }, { once: true });
  window.addEventListener('scroll', function () { schedule(450); }, { passive: true });
  window.addEventListener('pageshow', function () { schedule(300); });
})();
